export default {
    SADMIN_ROLE: 'super_admin',
    ADMIN_ROLE: 'admin',
    TEC_ROLE: 'tecnico',
    SUPV_ROLE: 'supervisor',
    VISIT_ROLE: 'visitante',
};



// WEBPACK FOOTER //
// ./src/constants.js